<app-page-meta pageTitle="finzy - My Profile"></app-page-meta>
<div class="fluid-container">
    <app-header *ngIf="finzyDomain"></app-header>
    <app-theader *ngIf="otherDomain"></app-theader>
    <div class="back-div">
        <a style="color: #0d3ab3;" (click)="backToPreviousPage()"> < Back </a>
    </div>
    <div class="content-profile-header">
        <p class="header text-center">
            Nominee Details
        </p>
        <div *ngIf="!checkNomineeExists()">
            <p class="sub-header text-center">
                Please add a nominee for your investments
            </p>
        </div>
        <div class="row" *ngIf="checkNomineeExists()">
        <p class="sub-header text-center">
            Here is your nominee for your investments
        </p>
        </div>
    </div>
    <div class="grey-section">
        <app-nominee-form></app-nominee-form>
        <div class="row" *ngIf="!checkNomineeExists() && !isEdit">
            <button mat-flat-button class="button-forward primary" type="button" (click)="activateForm()">
                Edit Nominee
            </button>
        </div>
        <div class="row" *ngIf="checkNomineeExists()">
            <button *ngIf="!isEdit" mat-flat-button class="button-forward primary" type="button"
                    (click)="activateForm()">
                <span>Edit Nominee</span>
            </button>
        </div>
        <div class="row" *ngIf="isEdit">
            <button mat-flat-button class="button-forward primary" type="button"
                    (click)="saveForm()">
                <span>Save Nominee</span>
            </button>
            <button mat-stroked-button class="button-back primary no-text-transform" type="button"
                    (click)="cancelForm()">
                CANCEL
            </button>
        </div>
    </div>
    <div class="text-center faq-contact-us">
        Check our <a [routerLink]="['/faq']" target="_blank">FAQs</a> or CALL <a href="tel: +919341300300">9341 300 300</a> for support
    </div>
</div>
<app-footer *ngIf="finzyDomain"></app-footer>
<app-tfooter *ngIf="otherDomain"></app-tfooter>
